import { PartialType, ApiProperty } from '@nestjs/swagger';
import { CreateChapterDto } from './create-chapter.dto';
import { IsOptional, IsString, IsArray, ArrayUnique, IsInt } from 'class-validator';
import { Type } from 'class-transformer';

export class UpdateChapterDto extends PartialType(CreateChapterDto) {
  @ApiProperty({ description: 'The title of the chapter', example: 'Updated Chapter Title', required: false })
  @IsOptional()
  @IsString()
  title?: string;

  @ApiProperty({ description: 'Array of newsfeed IDs to associate with this chapter', example: [4, 5], required: false, type: [Number] })
  @IsOptional()
  @IsArray()
  @ArrayUnique()
  @IsInt({ each: true })
  @Type(() => Number)
  newsfeeds?: number[];
}
